import { WebViewScreen } from '@/screens/webview-screen/WebViewScreen'

export default function () {
  return <WebViewScreen />
}
